/**
 * Returns a truncated date pointing to the first day of the `to` value.
 * This is typically used for Amplitude and mimics the behaviour of
 * https://cloud.google.com/bigquery/docs/reference/standard-sql/date_functions#date_trunc.
 */
export function truncateDateForAmplitude(date: Date, to: 'date' | 'week' | 'month'): string {
    const updated = new Date(date);

    switch (to) {
        case 'week': {
            // Get current day number in the week, converting Sun. to 7
            const day = updated.getDay() || 7;

            // Only manipulate the date if it isn't Monday.
            if (day !== 1) {
                // Set the hours to day number minus 1, multiplied by negative 24
                updated.setHours(-24 * (day - 1));
            }
            break;
        }
        case 'month':
            updated.setDate(1);
            break;
    }

    return dateToYYYYMMDD(updated);
}

/**
 * Formats a date to YYYY-MM-DD.
 */
export function dateToYYYYMMDD(date: Date): string {
    const offset = date.getTimezoneOffset();
    const updated = new Date(date.getTime() - offset * 60 * 1000);
    return updated.toISOString().split('T')[0].replace('/', '-');
}
